module.exports = __webpack_public_path__ + "img/Wp_2078.72272a01.png";